// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + ".dcb19719c75cf38aa5220357c6e0690cebfd867d.css";
};